import LocalizedStrings from "react-localization";

let headerStrings = new LocalizedStrings({
    en: {
        contact: "Contact Us",
        library: "Library",
        studios: "Studios",
        players: "Players",
        home: "Home",
        subscription: "Subscription",
    },
});

export default headerStrings;